import { TNeedleRequestStatus, TStoreNeedleRequest, TTicketNeedleRequest } from '@monorepo/types';
import { ACCORDION_TABLE_MODIFIER } from '../../model/accordion-table.modifier';
import { TAccordionTableVM } from '../../model/accordion-table.types';

export const NEEDLE_REQUEST_ACCORDION_TABLE_MODEL = {
  createGlobalStoreManagerRequestsModel(
    requests: TStoreNeedleRequest[],
    selectedRequestStatus: TNeedleRequestStatus,
    redirectedRequestId?: TStoreNeedleRequest['sparePartRequestId'],
  ): TAccordionTableVM {
    return ACCORDION_TABLE_MODIFIER.createModel(
      [
        { label: 'tm_container_labels.Date&Time', colSize: 10 },
        { label: 'tm_container_labels.LocationHeader', colSize: 12 },
      ],

      requests.map((request) => ({
        id: request.sparePartRequestId,
        isMinimized: redirectedRequestId ? !(redirectedRequestId === request.sparePartRequestId) : true,
        moreInfo: [
          {
            items: [
              {
                size: 12,
                label: 'tm_container_labels.RaisedBy',
                values: [{ displayName: request.requestedBy.employeeName }],
              },
            ],
          },
        ],
        rowItems: [
          { type: 'DATE_AND_TIME', timestamp: request.requestedAt },
          { type: 'TEXT', value: request.locationInfo.locationDisplayCode },
        ],
        actions:
          selectedRequestStatus === 'PENDING'
            ? [
                {
                  actionId: 'EXPAND_TICKET',
                  displayName: 'Approve',
                },
                {
                  actionId: 'REJECT',
                  displayName: 'Reject',
                },
              ]
            : [],
      })),
      {
        showExpand: true,
        ...(selectedRequestStatus === 'PENDING'
          ? {
              select: {
                isMulti: true,
              },
            }
          : {}),
      },
    );
  },

  createLocalStoreManagerRequestsModel(
    requests: TTicketNeedleRequest[],
    selectedRequestStatus: TNeedleRequestStatus,
    redirectedRequestId?: TStoreNeedleRequest['sparePartRequestId'],
  ): TAccordionTableVM {
    return ACCORDION_TABLE_MODIFIER.createModel(
      [
        { label: 'tm_container_labels.Date&Time', colSize: 10 },
        { label: 'tm_container_labels.LocationHeader', colSize: 12 },
      ],
      requests.map((request) => ({
        id: request.sparePartRequestId,
        moreInfo: [
          {
            items: [
              {
                size: 12,
                label: 'tm_container_labels.RaisedBy',
                values: [{ displayName: request.requestedBy.employeeName }],
              },
              {
                size: 12,
                label: 'table_model.MachineSerialId',
                values: [{ displayName: request.machineDescription.factorySerialNumber }],
              },
              {
                size: 12,
                label: 'table_model.MachineCategory',
                values: [{ displayName: request.machineDescription.machineCategory }],
              },
              {
                size: 12,
                label: 'table_model.MachineSub-Category',
                values: [{ displayName: request.machineDescription.machineSubCategory || '--' }],
              },
            ],
          },
        ],
        isMinimized: redirectedRequestId ? !(redirectedRequestId === request.sparePartRequestId) : true,
        rowItems: [
          { type: 'DATE_AND_TIME', timestamp: request.requestedAt },
          { type: 'TEXT', value: request.locationInfo.locationDisplayCode },
        ],
        actions:
          selectedRequestStatus === 'PENDING'
            ? [
                {
                  actionId: 'EXPAND_TICKET',
                  displayName: 'Approve',
                },
                {
                  actionId: 'REJECT',
                  displayName: 'Reject',
                },
              ]
            : [],
      })),
      {
        showExpand: true,
        ...(selectedRequestStatus === 'PENDING'
          ? {
              select: {
                isMulti: true,
              },
            }
          : {}),
      },
    );
  },
};

export const LOCAL_STORE_NEEDLE_REQUESTS_LIST_ACCORDION_TABLE_MODEL = {
  createModel(
    requests: TStoreNeedleRequest[],
    redirectedRequestId?: TStoreNeedleRequest['sparePartRequestId'],
  ): TAccordionTableVM {
    return ACCORDION_TABLE_MODIFIER.createModel(
      [
        { label: 'tm_container_labels.Date&Time', colSize: 10 },
        { label: 'tm_container_labels.LocationHeader', colSize: 12 },
      ],
      requests.map((request) => ({
        id: request.sparePartRequestId,
        isMinimized: redirectedRequestId ? !(redirectedRequestId === request.sparePartRequestId) : true,
        moreInfo: [
          {
            items: [
              {
                size: 12,
                label: 'table_model.AdditionalInfo',
                values: [{ displayName: request.requestAdditionalInfo || '--' }],
              },
            ],
          },
        ],
        rowItems: [
          { type: 'DATE_AND_TIME', timestamp: request.requestedAt },
          { type: 'TEXT', value: request.locationInfo.locationDisplayCode },
        ],
        actions: [],
      })),
      {
        showExpand: true,
      },
    );
  },
};
